<template>
    <section>
        <div id="printTemplate" class="print-container">
            <div v-if="printTemplate === $Constants.PRINT_TYPE_RECEIPT">
                <print-receipt :fields="fieldData" :globalStyle="styleSheet"></print-receipt>
            </div>
            <div v-if="printTemplate === $Constants.PRINT_TYPE_CLAIM">
                <print-claim :fields="fieldData" :globalStyle="styleSheet"></print-claim>
            </div>
            <div v-if="printTemplate === $Constants.PRINT_TYPE_INSPECTION">
                <print-inspection :fields="fieldData" :globalStyle="styleSheet"></print-inspection>
            </div>
        </div>
        
        <iframe id="printFrame" name="printFrame"></iframe>
    </section>
</template>

<script>
import PrintReceipt from '@/components/print/TemplateReceipt';
import PrintClaim from '@/components/print/TemplateClaim';
import PrintInspection from '@/components/print/TemplateInspection';

export default {
    components: {
        PrintReceipt,
        PrintClaim,
        PrintInspection
    },
    data() {
        return {
            fieldData: null,
            styleSheet: this.getStyleSet()
        }
    },
    props: {
        printData: Object,
        printTemplate: String
    },
    methods: {
        async printForm(content) {
            this.fieldData = content;

            setTimeout(() => {
                this.$AppUtility.printTemplate('printTemplate');
            }, 500);
        },
        getStyleSet() {
            return `
                .paper {
                    margin: 30px auto;
                    overflow: hidden;
                    background: #fff;
                    width: 20.6cm;
                    position: relative;
                    page-break-after: always;
                }
                .paper * {
                    font-family: Tahoma;
                    font-size: 11px;
                    -webkit-print-color-adjust: exact;
                    box-sizing: border-box;
                }
                .paper .header {
                    position: relative;
                    margin: 0 0 30px;
                }
                .paper .header h1 {
                    margin: 0;
                    text-align: center;
                    font-weight: bold;
                    font-size: 22px;
                }
                .paper .header * {
                    font-family: Tahoma;
                    font-size: 12px;
                }
                .paper .header .issue {
                    position: absolute;
                    top: 0;
                    right: 0;
                    text-align: right;
                }
                .paper .document-data {
                    overflow: hidden;
                    margin: 40px 0;
                }
                .paper .document-data .left {
                    float: left;
                    width: 40%
                }
                .paper .document-data .right {
                    float: right;
                    text-align: right;
                    width: 40%
                }
                .paper .bill-no {
                    margin: 40px 0 20px;
                    font-weight: bold;
                    font-size: 14px;
                    text-align: center;
                }
                .paper table, .paper th, .paper td {
                    border-left: 1px solid #999;
                    border-right: 1px solid #999;
                }
                .paper table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                    page-break-inside: avoid;
                }
                .paper table th {
                    background: #ddd;
                    text-align: left;
                    padding: 10px;
                    font-size: normal;
                    border-top: 1px solid #999;
                    border-bottom: 1px solid #999;
                }
                .paper table tr.order td {
                    height: 400px;
                }
                .paper table tr.space-top td {
                    padding-top: 10px;
                }
                .paper table tr.space-bottom td {
                    padding-bottom: 10px;
                }
                .paper table tr.line {
                    border-top: 1px solid #999;
                }
                .paper table tr.footer td {
                    background: #f2f2f2;
                }
                .paper table tr:last-child {
                    border-bottom: 1px solid #999;
                }
                .paper table td {
                    background: #fff;
                    padding: 5px;
                    vertical-align: top;
                }
                .paper table td .small {
                    font-size: 10px;
                    color: #666;
                    display: block;
                }
                .paper .text-center {
                    text-align: center;
                }
                .paper .text-right {
                    text-align: right;
                }
                .paper .text-justify {
                    text-align: justify;
                }
                .paper .text-strong {
                    font-weight: bold;
                }
                .paper .checkbox-group {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 2px 6px 2px 2px;
                    white-space: nowrap;
                }
                .paper .checkbox-group .checkbox {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 3px;
                    width: 15px;
                    height: 15px;
                    background: #fff;
                    border: 1px solid #333;
                }
                .paper .checkbox-group .checkbox span {
                    display: block;
                    text-align: center;
                    font-size: 12px;
                    line-height: 10px;
                }
                .paper .checkbox-group label {
                    margin: 0;
                }
                .paper .remark {
                    margin-top: 40px;
                    font-size: 10px;
                    line-height: 12px;
                }
                .paper .signature {
                    margin-top: 60px;
                    overflow: hidden;
                }
                .paper .signature .col {
                    display: inline-block;
                    vertical-align-top;
                }
                .paper .signature .space {
                    width: 10%;
                }
                .paper .signature .license {
                    width: 35%;
                }
                .paper .signature .license .line {
                    border-bottom: 1px dotted #333;
                }
                .paper .signature .license .date {
                    position: relative;
                    width: 50%;
                    margin: 30px auto 0;
                    border-bottom: 1px dotted #333;
                }
                .paper .signature .license .date:before {
                    content: "วันที่";
                    position: absolute;
                    top: -13px;
                    left: -40px;
                }
                .paper .signature .license label {
                    margin: 10px 0 0;
                    font-weight: bold;
                    text-align: center;
                    display: block;
                }
            `;
        }
    }
}
</script>

<style lang="scss" scoped>
.print-container {
    position: fixed;
    left: 0;
    overflow: hidden;
    z-index: -1;
    opacity: 0;
}

iframe {
    position: fixed;
    left: 0;
    opacity: 0;
    width: 0;
    height: 0;
    border: 0;
}
</style>